import { render, staticRenderFns } from "./OpenGridMatch.vue?vue&type=template&id=68c82045&scoped=true"
import script from "./OpenGridMatch.vue?vue&type=script&lang=js"
export * from "./OpenGridMatch.vue?vue&type=script&lang=js"
import style0 from "./OpenGridMatch.vue?vue&type=style&index=0&id=68c82045&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c82045",
  null
  
)

export default component.exports